import { render, staticRenderFns } from "./AddTeacherSection.vue?vue&type=template&id=b08ffcfa&scoped=true"
import script from "./AddTeacherSection.vue?vue&type=script&lang=js"
export * from "./AddTeacherSection.vue?vue&type=script&lang=js"
import style0 from "./AddTeacherSection.vue?vue&type=style&index=0&id=b08ffcfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08ffcfa",
  null
  
)

export default component.exports